import { setLegalAgreement, setLegalModal } from '../../../../store/signUp/slice';
import LegalContainer from '../../../../containers/Legal';
import { useDispatch } from '../../../../store/store';
import Button from '../../../../components/Button';
import Modal from '../../../../components/Modal';
import styles from './style.module.scss';

export default function Legal() {
    const dispatch = useDispatch();

    const agree = () => {
        dispatch(setLegalAgreement(true));
        dispatch(setLegalModal(false));
    };

    return (
        <Modal
            size='xxl'
            title='Legal'
            closeFunc={() => dispatch(setLegalModal(false))}
        >
            <LegalContainer />
            <div className={styles.actions}>
                <Button
                    type='Outline-Primary'
                    text='Cancel'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setLegalModal(false))}
                />
                <Button
                    text='Agree'
                    type='Primary'
                    onClick={agree}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
}
